import { Component, OnInit, Output, EventEmitter, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ProductFilters, Category } from '../../models/product.model';
import { VehicleMake, VehicleModel } from '../../models/vehicle.model';
import { ProductService } from '../../services/product.service';
import { VehicleService } from '../../services/vehicle.service';

@Component({
  selector: 'app-filters-sidebar',
  imports: [CommonModule, FormsModule],
  templateUrl: './filters-sidebar.component.html',
  styleUrl: './filters-sidebar.component.scss'
})
export class FiltersSidebarComponent implements OnInit {
  @Output() filtersChange = new EventEmitter<ProductFilters>();

  // Data
  protected categories = signal<Category[]>([]);
  protected vehicleMakes = signal<VehicleMake[]>([]);
  protected vehicleModels = signal<VehicleModel[]>([]);
  protected vehicleYears = signal<number[]>([]);

  // Filter values
  protected filters: ProductFilters = {};
  protected selectedCategories: number[] = [];

  // UI State
  protected sections = {
    vehicle: signal(true),
    category: signal(true),
    stock: signal(true),
    price: signal(false)
  };

  constructor(
    private productService: ProductService,
    private vehicleService: VehicleService
  ) {}

  ngOnInit(): void {
    this.loadCategories();
    this.loadVehicleMakes();
    this.loadYears();
  }

  loadCategories(): void {
    this.productService.getCategories().subscribe(cats => {
      this.categories.set(cats);
    });
  }

  loadVehicleMakes(): void {
    this.vehicleService.getVehicleMakes().subscribe(makes => {
      this.vehicleMakes.set(makes);
    });
  }

  loadYears(): void {
    this.vehicleService.getYears().subscribe(years => {
      this.vehicleYears.set(years);
    });
  }

  onMakeChange(makeId: string): void {
    this.filters.marcaVeiculo = makeId || undefined;
    this.filters.modeloVeiculo = undefined;
    
    if (makeId) {
      this.vehicleService.getVehicleModels(makeId).subscribe(models => {
        this.vehicleModels.set(models);
      });
    } else {
      this.vehicleModels.set([]);
    }

    this.emitFilters();
  }

  onModelChange(modelId: string): void {
    this.filters.modeloVeiculo = modelId || undefined;
    this.emitFilters();
  }

  onYearChange(year: string): void {
    this.filters.anoVeiculo = year ? parseInt(year) : undefined;
    this.emitFilters();
  }

  onCategoryChange(categoryId: number, checked: boolean): void {
    if (checked) {
      this.selectedCategories.push(categoryId);
    } else {
      this.selectedCategories = this.selectedCategories.filter(id => id !== categoryId);
    }

    this.filters.categoriaId = this.selectedCategories.length === 1 
      ? this.selectedCategories[0] 
      : undefined;

    this.emitFilters();
  }

  onStockChange(checked: boolean): void {
    this.filters.apenasEmEstoque = checked;
    this.emitFilters();
  }

  onPriceMinChange(value: string): void {
    this.filters.precoMin = value ? parseFloat(value) : undefined;
    this.emitFilters();
  }

  onPriceMaxChange(value: string): void {
    this.filters.precoMax = value ? parseFloat(value) : undefined;
    this.emitFilters();
  }

  clearFilters(): void {
    this.filters = {};
    this.selectedCategories = [];
    this.vehicleModels.set([]);
    this.emitFilters();
  }

  hasActiveFilters(): boolean {
    return Object.keys(this.filters).length > 0;
  }

  toggleSection(section: keyof typeof this.sections): void {
    this.sections[section].update(value => !value);
  }

  private emitFilters(): void {
    this.filtersChange.emit({ ...this.filters });
  }
}

